import { lazy, type ComponentType } from 'react'

type PageModule = { default: ComponentType }

export type LazyPage = ComponentType & {
  /** Baixa o código da página antes de renderizar (sem passar pelo fallback do Suspense). */
  preload: () => Promise<void>
}

/**
 * Igual a `React.lazy`, mas com `preload()`: depois de carregada, a página renderiza direto,
 * sem suspender. Usado na abertura do site (página pré-renderizada) e na pré-renderização do build.
 */
export function lazyPage(load: () => Promise<PageModule>): LazyPage {
  let Loaded: ComponentType | null = null

  const preload = () =>
    load().then((module) => {
      Loaded = module.default
    })

  const LazyComponent = lazy(() => load().then((module) => {
    Loaded = module.default
    return module
  }))

  function Page() {
    return Loaded ? <Loaded /> : <LazyComponent />
  }

  return Object.assign(Page, { preload })
}
